import api from './axiosConfig';

interface Account {
  name: string;
  lastname: string;
}

export interface AccountLog {
  id: number;
  accountid: number;
  logdate: string;
  title: string;
  description: string;
  username: string;
  account: Account;
}

export interface AccountLogCalling {
  id: number;
  accountid: number;
  logdate: string;
  title: string;
  description: string;
  username: string;
  account: Account;
}

export interface SystemLog {
  logdate: Date;
  logtype: string;
  title: string;
  description: string;
  username: string;
  account: Account;
}

interface SystemLogParams {
  datefrom?: string;
  dateto?: string;
}

export const getRecentLogs = async (): Promise<AccountLog[]> => {
  try {
    const response = await api.get<AccountLog[]>('recentactivity');
    return response.data;
  } catch (error) {
    console.error('Error fetching recent logs:', error);
    throw error;
  }
};

export const getRecentLogsCalling = async (): Promise<AccountLogCalling[]> => {
  try {
    const response = await api.get<AccountLogCalling[]>(
      'recentactivitycalling'
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching recent logs:', error);
    throw error;
  }
};

export const getSystemLogs = async (
  params?: SystemLogParams
): Promise<SystemLog[]> => {
  try {
    const response = await api.post<SystemLog[]>('systemlog', params);
    return response.data;
  } catch (error) {
    console.error('Error fetching system logs:', error);
    throw error;
  }
};
